"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = require("@jsluna/button");

var _form = require("@jsluna/form");

var _grid = require("@jsluna/grid");

var _icons = require("@jsluna/icons");

var _constants = require("../utils/constants");

var _ChoiceImage = _interopRequireDefault(require("./ChoiceImage"));

var _activityIcons = require("@jsainsburyplc/activity-icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ChoiceBuilderItem = function ChoiceBuilderItem(_ref) {
  var order = _ref.order,
      questionId = _ref.questionId,
      id = _ref.id,
      value = _ref.value,
      image = _ref.image,
      setValue = _ref.setValue,
      remove = _ref.remove,
      move = _ref.move,
      moveUpDisabled = _ref.moveUpDisabled,
      moveDownDisabled = _ref.moveDownDisabled,
      onAddImage = _ref.onAddImage,
      setBranchFrom = _ref.setBranchFrom,
      activeCondition = _ref.activeCondition,
      error = _ref.error,
      onRemoveImage = _ref.onRemoveImage;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '12/12',
      ss: '12/12',
      md: '12/12'
    }
  }, /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    required: true,
    maxLength: 100,
    value: value,
    placeholder: "Option " + (parseInt(order) + 1),
    onChange: function onChange(e) {
      return setValue(order, id, e.target.value);
    },
    name: questionId + "-choice-" + id,
    error: error
  }))), /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '12/12',
      ss: '12/12',
      md: '12/12'
    },
    className: "ln-u-hard-right"
  }, /*#__PURE__*/_react.default.createElement(_ChoiceImage.default, {
    image: image,
    showRemove: true,
    onRemove: function onRemove() {
      return onRemoveImage(id);
    },
    maxWidth: "300px"
  }))), /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '3/12',
      ss: '2/12',
      md: '2/12'
    }
  }, /*#__PURE__*/_react.default.createElement(_button.IconButton, {
    variant: "text",
    color: "dark",
    label: "Move option up",
    hideLabel: true,
    disabled: moveUpDisabled,
    onClick: function onClick() {
      return move(order, id, _constants.moveDirections.up);
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowUp, null))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '3/12',
      ss: '2/12',
      md: '2/12'
    }
  }, /*#__PURE__*/_react.default.createElement(_button.IconButton, {
    variant: "text",
    color: "dark",
    label: "Move option down",
    hideLabel: true,
    disabled: moveDownDisabled,
    onClick: function onClick() {
      return move(order, id, _constants.moveDirections.down);
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowDown, null))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '3/12',
      ss: '2/12',
      md: '2/12'
    }
  }, /*#__PURE__*/_react.default.createElement(_form.FormGroup, {
    name: "file-upload-form-" + id
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "file",
    id: "file-upload-input-" + id,
    style: {
      display: 'none'
    },
    accept: ".gif,.jpg,.jpeg,.png",
    multiple: false,
    onChange: function onChange(e) {
      return onAddImage(e, id);
    }
  }), /*#__PURE__*/_react.default.createElement(_button.IconButton, {
    variant: "text",
    color: "dark",
    label: "file upload",
    hideLabel: true,
    disabled: false,
    style: {
      boxShadow: 'none',
      backgroundColor: 'transparent'
    },
    onClick: function onClick() {
      document.getElementById("file-upload-input-" + id).click();
    }
  }, /*#__PURE__*/_react.default.createElement(_activityIcons.ImageUpload, null)))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '3/12',
      ss: '2/12',
      md: '2/12'
    }
  }, /*#__PURE__*/_react.default.createElement(_button.IconButton, {
    variant: "text",
    color: "dark",
    label: "Delete option",
    hideLabel: true,
    onClick: function onClick() {
      return remove(id);
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.Delete, null))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '1/1',
      ss: '4/12',
      md: '4/12'
    }
  }, Object.keys(activeCondition).length !== 0 ? /*#__PURE__*/_react.default.createElement(_button.LinkButton, {
    color: "dark",
    onClick: function onClick() {
      return setBranchFrom(questionId, id);
    },
    className: "ln-u-margin-bottom*4",
    fullWidth: true
  }, "Go to Q", activeCondition.question.position) : /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    onClick: function onClick() {
      return setBranchFrom(questionId, id);
    },
    className: "ln-u-bg-color-white ln-u-margin-bottom*4",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ln-u-display-none ln-u-display-inline@ss"
  }, "Go to ..."), /*#__PURE__*/_react.default.createElement("span", {
    className: "ln-u-display-none@ss"
  }, "Go to another question")))));
};

ChoiceBuilderItem.propTypes = {
  /** The order of the choice in the current choice list */
  order: _propTypes.default.number.isRequired,

  /** The unique identifier of the question */
  questionId: _propTypes.default.string.isRequired,

  /** The unique identifier of the choice */
  id: _propTypes.default.string.isRequired,

  /** The response value for this component */
  value: _propTypes.default.string,

  /** Function to set the response value for this component */
  setValue: _propTypes.default.func.isRequired,

  /** Function to remove the choice */
  remove: _propTypes.default.func.isRequired,

  /** Function to move the choice up/down */
  move: _propTypes.default.func.isRequired,

  /** The image value for this component */
  image: _propTypes.default.object,

  /** Flag to disable move up functionality */
  moveUpDisabled: _propTypes.default.bool,

  /** Flag to disable move down functionality */
  moveDownDisabled: _propTypes.default.bool,

  /** Function to set the question/value combination for branching questions */
  setBranchFrom: _propTypes.default.func.isRequired,

  /** The condition linked to this value for the question */
  activeCondition: _propTypes.default.object,

  /** Validation errors that are linked to the question */
  error: _propTypes.default.string,

  /** Callback fired when the image is uploaded */
  onAddImage: _propTypes.default.func,

  /** Callback fired when an image is removed from a choice */
  onRemoveImage: _propTypes.default.func
};
ChoiceBuilderItem.defaultProps = {
  value: '',
  moveUpDisabled: false,
  moveDownDisabled: false,
  activeCondition: {},
  error: null
};
var _default = ChoiceBuilderItem;
exports.default = _default;